/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Create_Project_Instructions_MaxInputs */



/**
* | output |
* | --- |
* | "Instructions must be less than {count} characters" |
*
* @param {Create_Project_Instructions_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_instructions_max = /** @type {((inputs: Create_Project_Instructions_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Instructions_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Anweisungen dürfen höchstens ${i?.count} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Instructions must be less than ${i?.count} characters`)
});